<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between">
      <div>
        <!-- <i class="ti ti-users text-success mr-2"></i> -->
        👨‍🔧 Technician
      </div>
      <span class="badge badge-primary">
        {{ employees.length }}
      </span>
    </div>

    <!-- <div class="card-body">
      <div
        v-for="item in employees"
        :key="item.nik"
        :class="[
          'employee-item',
          {
            active: selected && selected.nik == item.nik,
          },
        ]"
        @click="select(item)"
      >
        <div class="font-weight-bold">
          {{ item.firstname }} {{ item.lastname }}
        </div>

        <small class="text-muted">
          {{ item.nik }}
        </small>
      </div>
    </div> -->

    <div class="card-body technician-list">
      <div
        v-for="item in employees"
        :key="item.nik"
        :class="[
          'employee-item',
          {
            active: selected && selected.nik == item.nik,
          },
        ]"
        @click="select(item)"
      >
        <div class="font-weight-bold">
          {{ item.firstname }} {{ item.lastname }}
        </div>

        <small class="text-muted">
          {{ item.nik }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TechnicianPanel",

  props: {
    employees: {
      type: Array,

      default: () => [],
    },

    selected: {
      type: Object,

      default: null,
    },
  },

  methods: {
    select(item) {
      this.$emit(
        "select",

        item
      );
    },
  },
};
</script>

<style scoped>
.card {
  max-height: 100vh;
}

.card-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}

.technician-list {
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 6px;
}

/* Scrollbar */
.technician-list::-webkit-scrollbar {
  width: 6px;
}

.technician-list::-webkit-scrollbar-thumb {
  background: #c8c8c8;
  border-radius: 999px;
}

.technician-list::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}

.employee-item {
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.employee-item:hover {
  border-color: #0d6efd;
  background: #f5f9ff;
}

.employee-item.active {
  border-color: #007bff;
  background: #eef6ff;
}
</style>